import * as React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import HomeIcon from "@mui/icons-material/Home";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import GrainIcon from "@mui/icons-material/Grain";
import { Outlet, useLocation } from "react-router-dom";
import { Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";


const iconsArray = [GrainIcon, GraphicEqIcon, AutoAwesomeMotionIcon , GrainIcon, GraphicEqIcon, AutoAwesomeMotionIcon];
export default function PageBreadcrumbs() {
  const locationPath = useLocation().pathname;
  const navigate = useNavigate();

  const [breadCrumbArrayData, setBreadCrumbArrayData] = React.useState([]);

  //console.log(locationPath);
  React.useEffect(() => {
    const locationArray = locationPath
      ?.split("/")
      ?.filter((item) => isNaN(item));
    let arrayNav = [];
    let tempID;

    locationPath?.split("/").forEach((item) => {
      if(item===""){
   
        return;
      }
      if (Boolean(tempID)) {
        arrayNav.push({
          navigateTo: `${arrayNav[arrayNav.length - 1]?.navigateTo}/${tempID}/${item}`,
          title: item.replace("-", " ").replace("_", " "),
          icon: iconsArray[arrayNav.length],
        });
        tempID = ""
  
      } else {
        if (!isNaN(item)) {
          tempID = item;
       
          return;
        }
        if(!Boolean(arrayNav.length)){
          arrayNav.push({
          navigateTo: `${item}`,
          title: item.replace("-", " ").replace("_", " "),
          icon: iconsArray[arrayNav.length],
        })
        }else{
          arrayNav.push({
          navigateTo: `${arrayNav[arrayNav.length - 1]?.navigateTo}/${item}`,
          title: item.replace("-", " ").replace("_", " "),
          icon: iconsArray[arrayNav.length],
        });
        }

      }
    });


    setBreadCrumbArrayData([
      { navigateTo: "", title: "Dashboard", icon: HomeIcon },
  
      ...arrayNav,
    ]);
  }, [locationPath]);
  return (
    
    <div role="presentation">
    {
        breadCrumbArrayData.length > 1 ?  
        <Paper sx={{ marginBottom: "10px", padding: "5px" }}>
        <Breadcrumbs maxItems={4} aria-label="breadcrumb" separator="›">
          {breadCrumbArrayData.map((item, index, array) => {
            let Icon = item.icon;
            if (array.length === index + 1) {
              return (
                <Link
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    textTransform: "capitalize",
                    color: "black",
                    textDecoration: "none",
                    fontWeight: "bold",
                  }}
                  color="inherit"
                  key={index}
                >
                  <Icon sx={{ mr: 0.5 }} fontSize="inherit" />
                  {item.title}
                </Link>
              );
            }
            return (
              <Link
                underline="hover"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  textTransform: "capitalize",
                }}
                color="inherit"
                key={index}
                onClick={() => navigate(`/${item.navigateTo}`)}
              >
                <Icon sx={{ mr: 0.5 }} fontSize="inherit" />
                {item.title}
              </Link>
            );
          })}
        </Breadcrumbs>
      </Paper> 
      :
      <></>
    }
     

    
    </div>
  );
}
